<template>
    <div v-loading="allLoading">

        <div style="height: 45px;
        line-height: 45px;
        font-size: 22px;
        background-color: rgb(247 244 244);
        padding-left: 10px;
        font-weight: 600;">
            {{ match ? match.MatchName : '' }}
            <span style="margin-left: 10px;font-size: 12px;text-decoration: underline;cursor: pointer;"
                @click="choiceMatchDialogVisible = true">重新选择</span>

            <div style="float: right;margin-right: 10px;" v-if="routeMatchId != ''">
                <el-tooltip content="排行榜大屏" placement="bottom" effect="light">
                    <el-button icon="el-icon-31paixingbang" style="font-size: 22px;" @click="toMatchRank"
                        circle></el-button>
                </el-tooltip>
            </div>
            <!-- <div style="float: right;margin-right: 10px;" v-if="routeMatchId != ''">
                <el-button size="small" @click="toMatchScoreView">成绩看榜</el-button>
            </div> -->
        </div>


        <div class="content" style="display: flex;">
            <div style="width: 15%;height: 80vh;overflow: hidden;overflow-y: auto;" class="project-list">
                <el-collapse v-model="activeNames">
                    <el-collapse-item v-for="(venue, index) in matchWholeSchedule" :title="venue.VenueName"
                        :name="index">
                        <div v-for="(pro, subIndex) in venue.MatchVenueProject" class="pro-item"
                            :class="choicePro && choicePro.ProjectId == pro.Project.ProjectId ? 'choicePro' : ''"
                            @click="choiceProject(pro.Project)">
                            {{ subIndex + 1 }}、{{ pro.Project.GroupTypeName + pro.Project.GroupName +
                                pro.Project.GenderRuleText +
                                pro.Project.ProjectName }}
                            <span>({{ pro.Project.ContestantUserGroupNum }}组{{ pro.Project.ContestantUserNum
                            }}人/队)</span>
                            <i style="font-size: 18px;color: green;margin: 0 2px;" class="el-icon-paixing"
                                v-if="pro.Project.IsSetRanking"></i>
                            <i style="font-size: 18px;color: green;margin: 0 2px;" class="el-icon-gongbu"
                                v-if="pro.Project.IsDisclosure == 1"></i>
                        </div>
                    </el-collapse-item>
                </el-collapse>
            </div>
            <div style="width: 85%;" class="details">
                <div v-if="project" class="pro-name">
                    {{ project.GroupTypeName + project.GroupName + project.GenderRuleText + project.ProjectName }}
                    <span>({{ project.ContestantUserGroupNum }}组{{ project.ContestantUserNum }}人/队)</span>
                    <i class="el-icon-refresh" style="cursor: pointer;" @click="choiceProject(choicePro)"></i>
                </div>

                <div v-if="isShowDetail">
                    <el-table :data="editProjectContestantUsers" size="small" max-height="600" stripe row-key="UserId" border="">
                        <el-table-column label="名次" prop="Ranking" width="70px" align="center">
                            <template slot-scope="scope">
                                <!-- <el-input-number v-model="scope.row.Ranking"  size="mini" style="width: 80px;"  controls-position="right"></el-input-number> -->
                                <el-input v-model="scope.row.Ranking" size="mini" style="width: 50px;"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="区域" width="100" align="center">
                            <template slot-scope="scope">
                                {{ scope.row.RegionName }}
                            </template>
                        </el-table-column>
                        <el-table-column label="序号" width="140" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.ComeOnGroup" size="mini" style="width: 50px;"></el-input> /
                                <el-input v-model="scope.row.ComeOnNum" size="mini" style="width: 50px;"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="姓名" prop="UserName" width="150" align="center"></el-table-column>
                        <el-table-column label="单位" prop="Unit" width="180" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'"
                            label="次数" prop="SpeedTimes" width="100" align="center"></el-table-column>
                        <el-table-column v-if="
                            project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                            || project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                            || project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'
                            || project.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'
                            || project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                            || project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                            || project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                            || project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                            || project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                            || project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                            || project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                            || project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                            || project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                            || project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                            || project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                        " label="难度分D" prop="D_Score" width="80" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                            || project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                            || project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                            || project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                            || project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                            || project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                            || project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                            || project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                            || project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                            || project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                        " label="重复难度U" prop="U_Score" width="80" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                            || project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                            || project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                            || project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                            || project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                            || project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                            || project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                            || project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                            || project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                            || project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                        " label="表现P" prop="P_Score" width="80" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                            || project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                            || project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                            || project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                            || project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                            || project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                            || project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                            || project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                            || project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                            || project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                            || project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                            || project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                            " label="规定Q"
                            prop="Q_Score" width="80" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                            || project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                            || project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                            || project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                            || project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                            || project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                            || project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                            || project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                            || project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                            || project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                        " label="失误M" prop="M_Score" width="80" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
                            || project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            || project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
                            || project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                            || project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                            || project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                        " label="创意编排分" prop="CA_Score" width="100" align="center"></el-table-column>
                        <el-table-column v-if="project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'
                            || project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            || project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
                            || project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                            || project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                            || project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'" label="完成质量分"
                            prop="CQ_Score" width="100" align="center"></el-table-column>

                        <el-table-column label="扣分次数" prop="DeductPointFrequency" width="100" align="center">
                            <!-- <template slot-scope="scope">
                                <el-input v-model="scope.row.DeductPointFrequency" size="mini"
                                    style="width: 80px;"></el-input>
                            </template> -->
                        </el-table-column>
                        <el-table-column label="成绩" prop="Score" width="100" align="center">
                            <template slot-scope="scope">
                                <span style="text-decoration: underline;cursor: pointer;"
                                    @click="showEditPointDialog(scope.row.UserId)">{{ scope.row.Score }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column label="得分" width="100" prop="TotalPoints" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.TotalPoints" size="mini" style="width: 80px;"></el-input>
                            </template>
                        </el-table-column>
                        <el-table-column label="弃" width="50" align="center">
                            <template slot-scope="scope">
                                <!-- <el-checkbox v-model="scope.row.IsWaiverChecked"></el-checkbox> -->
                                 {{ scope.row.IsWaiverChecked ? '✅' : '' }}
                            </template>
                        </el-table-column>
                        <el-table-column label="违例" width="50" align="center">
                            <template slot-scope="scope">
                                <!-- <el-checkbox v-model="scope.row.Status == 5"></el-checkbox> -->
                                 {{ scope.row.Status == 5 ? '✅' : '' }}
                            </template>
                        </el-table-column>
                       <!--  <el-table-column label="退" width="50" align="center">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.IsWithdrawMidwayChecked"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column label="测" width="50" align="center">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.IsTestChecked"></el-checkbox>
                            </template>
                        </el-table-column>
                        <el-table-column label="破" width="50" align="center">
                            <template slot-scope="scope">
                                <el-checkbox v-model="scope.row.IsRecordBreakingChecked"></el-checkbox>
                            </template>
                        </el-table-column> -->


                        <el-table-column label="备注" prop="Remarks" align="center">
                            <template slot-scope="scope">
                                <el-input v-model="scope.row.Remarks" size="mini"></el-input>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div style="margin-top: 10px" v-if="this.editProjectContestantUsers.length > 0 && isShowDetail">
                    <!-- <el-select v-model="rankingOrderType" size="small">
                        <el-option :value="0" label="根据成绩倒序"></el-option>
                        <el-option :value="1" label="根据成绩正序"></el-option>
                    </el-select> -->
                    <el-select v-model="rankingOrderNum" size="small">
                        <el-option :value="10" label="录取前10名" />
                        <el-option :value="8" label="录取前8名" />
                        <el-option :value="6" label="录取前6名" />
                        <el-option :value="12" label="录取前12名" />
                        <el-option :value="16" label="录取前16名" />
                        <el-option :value="24" label="录取前24名" />
                        <el-option :value="3" label="录取前3名" />
                        <el-option :value="4" label="录取前4名" />
                        <el-option :value="5" label="录取前5名" />
                    </el-select>
                    <el-button size="small" @click="handlerRanking">成绩排行</el-button>

                    <el-dropdown style="margin: 0 10px;" @command="sysDistributePoint">
                        <el-button type="primary" size="small">
                            系统派分<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="1">1倍</el-dropdown-item>
                            <el-dropdown-item command="2">2倍</el-dropdown-item>
                            <el-dropdown-item command="3">3倍</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <!-- <el-button size="small" @click="sysDistributePoint">系统派分</el-button> -->
                    <el-button type="primary" size="small" @click="submitEdit">保存数据</el-button>
                    <el-dropdown style="margin: 0 10px;" @command="exportProjectScore">
                        <el-button type="primary" size="small">
                            导出<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="all">全部</el-dropdown-item>
                            <el-dropdown-item command="rank">仅名次</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button type="primary" size="small" @click="setDisclosureStatus">
                        {{ project.IsDisclosure == 0 ? '公布成绩' : '隐藏成绩' }}
                    </el-button>
                    <!-- <el-button type="primary" size="small" @click="exportProjectScore">导出</el-button> -->
                </div>
                <div style="margin: 20px 0;">
                    <!-- <el-button type="primary" size="small" @click="showTeamRankDialog">团队排行</el-button> -->
                    <!-- <el-button type="primary" size="small" @click="exportAllProjectScore">导出所有项目名次</el-button> -->

                    <el-dropdown style="margin: 0 10px;" @command="exportAllProjectScore">
                        <el-button type="primary" size="small">
                            导出所有项目成绩<i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item command="0">全部</el-dropdown-item>
                            <el-dropdown-item command="1">仅名次</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>

                    <el-button type="primary" size="small" @click="showSetDistributePointDialog">设置派分规则</el-button>
                </div>

            </div>
        </div>



        <el-dialog title="设置派分规则" :visible.sync="distributePointDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="800px">

            <div>
                <el-form style="width: 400px;margin:  0 auto;" label-width="80px">
                    <el-form-item v-for="(item, index) in editDistributePointRuleForm" :label="'名次' + (index + 1)">
                        <el-input-number size="small" v-model="item.point" :min="0"></el-input-number>
                        <el-button v-if="index != 0" size="small" type="danger"
                            @click="editDistributePointRuleForm.splice(index, 1)">删除</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button @click="addDistributePointRuleItem" size="small">添加</el-button>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">

                <el-dropdown @command="fastGenerateRankPoint" size="small" style="margin-right: 10px;">
                    <el-button type="primary" size="small">
                        快速生成<i class="el-icon-arrow-down el-icon--right"></i>
                    </el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item command="8">8名次制</el-dropdown-item>
                        <el-dropdown-item command="6">6名次制</el-dropdown-item>
                        <el-dropdown-item command="12">12名次制</el-dropdown-item>
                        <el-dropdown-item command="16">16名次制</el-dropdown-item>
                        <el-dropdown-item command="24">24名次制</el-dropdown-item>
                        <el-dropdown-item command="3">3名次制</el-dropdown-item>
                        <el-dropdown-item command="4">4名次制</el-dropdown-item>
                        <el-dropdown-item command="5">5名次制</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>



                <el-button type="primary" size="small" @click="submitDistributePoint">确定</el-button>
                <el-button size="small" @click="distributePointDialogVisible = false">取消</el-button>
            </span>
        </el-dialog>


        <el-dialog title="团队排行" :visible.sync="showTeamRankDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="800px">

            <div>

            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showTeamRankDialogVisible = false">取消</el-button>
            </span>
        </el-dialog>



        <el-dialog title="选择赛事" :visible.sync="choiceMatchDialogVisible" :close-on-press-escape="false"
            :show-close="false" width="400px">

            <div style="text-align: center;">
                <el-select clearable filterable remote reserve-keyword placeholder="请输入关键词" size="small"
                    :remote-method="remoteMethod" v-model="matchId">
                    <el-option v-for="item in matchOptions" :label="item.MatchName" :value="item.MatchId">
                    </el-option>
                </el-select>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" size="small" @click="confirmChoiceMatch">确定</el-button>
            </span>
        </el-dialog>



        <el-dialog title="运动员成绩" class="adaptive" :visible.sync="editPointDialogVisible" :show-close="true"
            :close-on-press-escape="true" :close-on-click-modal="false" :fullscreen="true">

            <div v-if="userScoreDetail.Project
                && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'
                    || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'
                    || userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                    || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                    || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                )">
                <table>
                    <tr>
                        <th>主裁扣分</th>
                        <th>D难度</th>
                        <th>U重复</th>
                        <th>P完成</th>
                        <th v-if="userScoreDetail.Project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">
                            Q规定
                        </th>
                        <th>M失误</th>
                        <th>R成绩</th>
                    </tr>
                    <tr>
                        <td>{{ userScoreDetail.DeductPointScore > 0 ? userScoreDetail.DeductPointScore * -1 : 0 }}</td>
                        <td>{{ userScoreDetail.D_Score }}</td>
                        <td>{{ userScoreDetail.U_Score }}</td>
                        <td>{{ userScoreDetail.P_Score }}</td>
                        <td v-if="userScoreDetail.Project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">{{
                            userScoreDetail.Q_Score }}</td>
                        <td>{{ userScoreDetail.M_Score }}</td>
                        <td>{{ userScoreDetail.FinalTotalScore }}</td>
                    </tr>
                </table>
            </div>
            <!-- 国内赛 -->
            <div v-if="userScoreDetail.Project
                && (userScoreDetail.Project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                    || userScoreDetail.Project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
                    || userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                    || userScoreDetail.Project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                    || userScoreDetail.Project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'
                    || userScoreDetail.Project.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'
                    || userScoreDetail.Project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A'
                )">
                <table>
                    <tr>
                        <th>主裁扣分</th>
                        <th v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">难度</th>
                        <th v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">重复难度
                        </th>
                        <th v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                            && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">创意编排
                        </th>
                        <th v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                            && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">完成质量
                        </th>
                        <th v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
                            && userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                            && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">规定元素
                        </th>
                        <th>总分</th>
                    </tr>
                    <tr>
                        <td>{{ userScoreDetail.DeductPointScore > 0 ? userScoreDetail.DeductPointScore * -1 : 0 }}</td>
                        <td v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
                            {{ userScoreDetail.D_Portion_Score }}</td>
                        <td v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
                            {{ userScoreDetail.U_Portion_Score }}</td>
                        <td v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                            && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">{{
                                userScoreDetail.CA_Score }}</td>
                        <td v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                            && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">{{
                                userScoreDetail.CQ_Score }}</td>
                        <td v-if="userScoreDetail.Project.ProjectTypeId != 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                            && userScoreDetail.Project.ProjectTypeId != 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'
                            && userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                            && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                            {{ userScoreDetail.Q_Score }}</td>
                        <td>{{ userScoreDetail.FinalTotalScore }}</td>
                    </tr>
                </table>
            </div>

            <!--扣分次数-->
            <div class="score-group-item">
                <table border="1">
                    <tr>
                        <th colspan="2">扣分次数</th>
                        <th><el-button size="mini" @click="addScoreGroup('扣分次数')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.DeductPointItems">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.DeductPointCount" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DeductPointItems, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--计次-->
            <div class="score-group-item"
                v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'F679B7E4-F852-4A2A-BAF2-EC21BE923826'">
                <table border="1">
                    <tr>
                        <th colspan="2">计次</th>
                        <th><el-button size="mini" @click="addScoreGroup('计次')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.Times">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Times" controls-position="right" size="mini"
                                style="width: 110px;"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete" @click="delScoreGroupItem(userScoreDetail.Times, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--创意编排分-->
            <div class="score-group-item"
                v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'">
                <table border="1">
                    <tr>
                        <th colspan="2">创意编排分</th>
                        <th><el-button size="mini" @click="addScoreGroup('创意编排分')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            分数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.CreativeArrangementGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CreativeArrangementGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--完成质量分-->
            <div class="score-group-item"
                v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'A8CF0C94-4A2B-495C-8E4C-861357928917'">
                <table border="1">
                    <tr>
                        <th colspan="2">完成质量分</th>
                        <th><el-button size="mini" @click="addScoreGroup('完成质量分')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            分数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.CompletionQualityGroups">
                        <td>
                            <el-select size="mini" v-model="item.referee.RefereeId" filterable placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                            <!-- {{ item.referee.RefereeName }} -->
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;"></el-input-number>
                        </td>
                        <td>
                            <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CompletionQualityGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--难度分D-->
            <div class="score-group-item"
                v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
                <table border="1">
                    <tr>
                        <th colspan="10">难度分D</th>
                        <th><el-button size="mini" @click="addScoreGroup('难度分D')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.d">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.d">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.D_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.D_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--重复难度U-->
            <div class="score-group-item"
                v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
                <table border="1">
                    <tr>
                        <th colspan="7">重复难度U</th>
                        <th><el-button size="mini" @click="addScoreGroup('重复难度U')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.U_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.U_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--完成分-->
            <div class="score-group-item" style="display: flex;"
                v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
                <table border="1">
                    <tr>
                        <th colspan="4">Pa动作技能</th>
                        <th><el-button size="mini" @click="addScoreGroup('Pa动作技能')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            记录
                        </th>
                        <th v-for="item in score.p.pa">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.p.pa">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Pa_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Pa_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1">
                    <tr>
                        <th colspan="4">Pr娱乐编排</th>
                        <th><el-button size="mini" @click="addScoreGroup('Pr娱乐编排')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            记录
                        </th>
                        <th v-for="item in score.p.pre">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.p.pre">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Pr_E_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Pr_E_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1">
                    <tr>
                        <th colspan="4">Pr音乐运用</th>
                        <th><el-button size="mini" @click="addScoreGroup('Pr音乐运用')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            记录
                        </th>
                        <th v-for="item in score.p.prm">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.p.prm">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Pr_M_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Pr_M_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--Fs形式风格-->
            <div class="score-group-item"
                v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C'">
                <table border="1">
                    <tr>
                        <th colspan="4">Fs形式风格</th>
                        <th>
                            <el-button size="mini" @click="addScoreGroup('Fs形式风格')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            记录
                        </th>
                        <th v-for="item in score.p.fs">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.p.fs">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.FS_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.FS_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 集体自编规定分 -->
            <div class="score-group-item" style="display: flex;"
                v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
                <table border="1"">
                    <tr>
                        <th colspan=" 6">规定Q</th>
                    <th><el-button size="mini" @click="addScoreGroup('【集体自编赛】规定Q')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            类别
                        </th>
                        <th v-for="item in score.c_q">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            满分数
                        </th>
                        <th v-for="item in score.c_q">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScoreValue" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--规定分、失误违例-->
            <div class="score-group-item" style="display: flex;"
                v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D' || userScoreDetail.Project.ProjectTypeId == 'B5D7A393-8CF1-45C0-8776-CD9D7DC2C01C')">
                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId == '54D80337-77B2-4C38-BC3A-7880113D5F8D'">
                    <tr>
                        <th colspan="4">规定Q</th>
                        <th><el-button size="mini" @click="addScoreGroup('规定Q')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            类别
                        </th>
                        <th v-for="item in score.q">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            满分数
                        </th>
                        <th v-for="item in score.q">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScoreValue" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1">
                    <tr>
                        <th colspan="2">Pa失误</th>
                        <th><el-button size="mini" @click="addScoreGroup('Pa失误')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Mistake_Pa_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Mistake_Pa_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1">
                    <tr>
                        <th colspan="2">Q失误</th>
                        <th><el-button size="mini" @click="addScoreGroup('Q失误')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Mistake_Q_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Mistake_Q_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1">
                    <tr>
                        <th colspan="2">违例</th>
                        <th><el-button size="mini" @click="addScoreGroup('违例')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.V_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.V_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!-- 国内个人规定赛，集体规定赛 完成质量/创意编排-->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project && (userScoreDetail.Project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'
                || userScoreDetail.Project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67')">
                <table border="1"
                    v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'B5F1B35F-FD39-4F5D-83CA-9972A21BC8C1'">
                    <tr>
                        <th colspan="4">完成质量</th>
                        <th><el-button size="mini" @click="addScoreGroup('【国内个人规定赛】完成质量')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.cpr_cq">
                            {{ item.t }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            满分数
                        </th>
                        <th v-for="item in score.cpr_cq">
                            {{ item.m }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.CompletionQualityGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScoreValue" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CompletionQualityGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <table border="1"
                    v-if="userScoreDetail.Project && userScoreDetail.Project.ProjectTypeId == 'FA8BBD50-62E3-47A0-A611-F70D34F29A67'">
                    <tr>
                        <th colspan="6">完成质量</th>
                        <th>
                            <el-button size="mini" @click="addScoreGroup('【国内集体规定赛】完成质量')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.ctr_cq">
                            {{ item.t }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            满分数
                        </th>
                        <th v-for="item in score.ctr_cq">
                            {{ item.m }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.CompletionQualityGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScoreValue" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CompletionQualityGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <table border="1">
                    <tr>
                        <th colspan="3">创意编排</th>
                        <th><el-button size="mini" @click="addScoreGroup('【国内个人/集体规定赛】创意编排')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.cr_ca">
                            {{ item.t }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            满分数
                        </th>
                        <th v-for="item in score.cr_ca">
                            {{ item.m }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.CreativeArrangementGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScoreValue" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CreativeArrangementGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 国内表演赛/花样赛 难度分 -->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project && ['39E56A5E-CB75-4245-AA8C-C0553C6C4ADF',
                '528D50AF-3268-45B7-A0B2-6C25D6759095',
                'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A',
                '7427106A-8F3D-4990-803E-C10B92ED618F',
                'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3']
                .indexOf(userScoreDetail.Project.ProjectTypeId) > -1">
                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                    <tr>
                        <th colspan="2">{{ this.score.c_d1.l }}</th>
                        <th><el-button size="mini" @click="addScoreGroup('一级难度')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th>
                            {{ this.score.c_d1.v }}
                        </th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.D1_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.D1_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'">
                    <tr>
                        <th colspan="2">{{ this.score.c_d2.l }}</th>
                        <th><el-button size="mini" @click="addScoreGroup('二级难度')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th>
                            {{ this.score.c_d2.v }}
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.D2_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.D2_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!-- 非国内集体个人花样显示-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                    && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                    <tr>
                        <th colspan="2">{{ this.score.c_d3.l }}</th>
                        <th><el-button size="mini" @click="addScoreGroup('三级难度')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th>
                            {{ this.score.c_d3.v }}
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.D3_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.D3_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 国内表演赛/花样赛 重复难度分 -->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project && ['39E56A5E-CB75-4245-AA8C-C0553C6C4ADF',
                '528D50AF-3268-45B7-A0B2-6C25D6759095',
                'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A',
                '7427106A-8F3D-4990-803E-C10B92ED618F',
                'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3']
                .indexOf(userScoreDetail.Project.ProjectTypeId) > -1">
                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                    <tr>
                        <th colspan="2">重复{{ this.score.c_u1.l }}</th>
                        <th><el-button size="mini" @click="addScoreGroup('重复一级难度')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th>
                            {{ this.score.c_u1.v }}
                        </th>
                        <th>操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.U1_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.U1_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'">
                    <tr>
                        <th colspan="2">重复{{ this.score.c_u2.l }}</th>
                        <th><el-button size="mini" @click="addScoreGroup('重复二级难度')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th>
                            {{ this.score.c_u2.v }}
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.U2_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.U2_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!-- 非国内集体个人花样显示-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId != '7427106A-8F3D-4990-803E-C10B92ED618F'
                    && userScoreDetail.Project.ProjectTypeId != 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'">
                    <tr>
                        <th colspan="2">重复{{ this.score.c_u3.l }}</th>
                        <th><el-button size="mini" @click="addScoreGroup('重复三级难度')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th>
                            {{ this.score.c_u3.v }}
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.U3_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.U3_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 国内表演赛/花样赛 完成质量/创意编排分 -->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
                && (userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                    || userScoreDetail.Project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
                    || userScoreDetail.Project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A')">
                <table border="1">
                    <tr>
                        <th colspan="6">创意编排</th>
                        <th><el-button size="mini" @click="addScoreGroup('【国内表演赛/花样赛】创意编排')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.c_ca">
                            {{ item.t }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            满分数
                        </th>
                        <th v-for="item in score.c_ca">
                            {{ item.m }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.CA_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScore" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CA_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <table border="1">
                    <tr>
                        <th colspan="5">完成质量</th>
                        <th>
                            <el-button size="mini" @click="addScoreGroup('【国内表演赛/花样赛】完成质量')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.c_cq">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.c_cq">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.CQ_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini" :min="0"
                                :max="s.MaxScore" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.CQ_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 国内表演赛 规定元素 -->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
                && (userScoreDetail.Project.ProjectTypeId == 'A66C8472-C5D5-4C66-85AD-7B2ABF1D680A')">
                <table border="1">
                    <tr>
                        <th colspan="6">规定元素</th>
                        <th><el-button size="mini" @click="addScoreGroup('【国内表演赛】规定元素')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.c_q">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            次数
                        </th>
                        <th v-for="item in score.c_q">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Frequency" controls-position="right" size="mini" :min="0"
                                :max="s.MustFrequency" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!-- 国内花样赛 规定元素 -->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
                && (userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                    || userScoreDetail.Project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095')">

                <table border="1">
                    <tr>
                        <th colspan="5">规定元素<span style="color:red !important;">(注意：裁判无需打分的项请留空，该项不会加入平均分的计算)</span>
                        </th>
                        <th><el-button size="mini" @click="addScoreGroup('【国内花样赛】规定元素')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.c_q2">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            次数
                        </th>
                        <th v-for="item in score.c_q2">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input type="number" v-model="s.Frequency" controls-position="right" size="mini"
                                :disabled="userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                                    && s.Type == '互相配合'" :max="s.MustFrequency" style="width: 110px;"
                                @change="calcScore"></el-input>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

            </div>

            <!--精英花样难度分/精英级表演赛-->
            <!--难度分D-->
            <div class="score-group-item" v-if="userScoreDetail.Project &&
                (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                    || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                    || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                )">
                <!--DP难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">

                    <tr>
                        <th colspan="10">DP难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DP难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.dp">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.dp">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DP_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DP_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DM难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">
                    <tr>
                        <th colspan="10">DM难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DM难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.dm">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.dm">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DM_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DM_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DR难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">

                    <tr>
                        <th colspan="10">DR难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DR难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.dr">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.dr">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DR_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DR_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DA难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                ">
                    <tr>
                        <th colspan="10">DA难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DA难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.da">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.da">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DA_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DA_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DB难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'">
                    <tr>
                        <th colspan="10">DB难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DB难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.db">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.db">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DB_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DB_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DJ难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'">
                    <tr>
                        <th colspan="16">DJ难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DJ难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.dj">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.dj">
                            {{ item.v.toFixed(2) }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DJ_ScoreGroups">
                        <td style="width: 120px;">
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DJ_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DT难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'">
                    <tr>
                        <th colspan="16">DT难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DT难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.dt">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.dt">
                            {{ item.v.toFixed(2) }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.DT_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.DT_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--重复难度U-->
            <div class="score-group-item" v-if="userScoreDetail.Project &&
                (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                    || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                    || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                )">
                <!--DP重复难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">

                    <tr>
                        <th colspan="10">DP重复难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DP重复难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u_dp">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u_dp">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.UDP_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.UDP_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DM重复难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">
                    <tr>
                        <th colspan="10">DM重复难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DM重复难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u_dm">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u_dm">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.UDM_ScoreGroups">
                        <td style="width: 120px;">
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.UDM_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DR重复难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'">
                    <tr>
                        <th colspan="10">DR重复难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DR重复难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u_dr">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u_dr">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.UDR_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.UDR_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DA重复难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'">
                    <tr>
                        <th colspan="10">DA重复难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DA重复难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u_da">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u_da">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.UDA_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.UDA_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DB重复难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'">
                    <tr>
                        <th colspan="10">DB重复难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DB重复难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u_db">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u_db">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.UDB_ScoreGroups">
                        <td style="width: 120px;">
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.UDB_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--DT重复难度分-->
                <table border="1" v-if="userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'">
                    <tr>
                        <th colspan="16">DT重复难度分</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】DT重复难度分')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th v-for="item in score.u_dt">
                            {{ item.l }}级
                        </th>
                        <th rowspan="2" style="width: 50px;">操作</th>
                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.u_dt">
                            {{ item.v.toFixed(2) }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.UDT_ScoreGroups">
                        <td style="width: 120px;">
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.UDT_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--表现分P-->
            <div class="score-group-item" style="display: flex;flex-wrap: wrap;" v-if="userScoreDetail.Project &&
                (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                    || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                    || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                )">
                <!--音乐-->
                <table border="1">

                    <tr>
                        <th colspan="16">表现分P</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】表现P')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>类型</th>
                        <th colspan="3">音乐</th>
                        <th colspan="3">完成质量</th>
                        <th colspan="3">创意</th>
                        <th colspan="3">娱乐</th>
                        <th colspan="3">多样性/重复性</th>
                        <th rowspan="3">操作</th>
                    </tr>
                    <tr>
                        <th>
                            记录
                        </th>
                        <th v-for="item in score.p2.m">
                            {{ item.l }}
                        </th>
                        <th v-for="item in score.p2.cq">
                            {{ item.l }}
                        </th>
                        <th v-for="item in score.p2.ca">
                            {{ item.l }}
                        </th>
                        <th v-for="item in score.p2.r">
                            {{ item.l }}
                        </th>
                        <th v-for="item in score.p2.v">
                            {{ item.l }}
                        </th>

                    </tr>
                    <tr>
                        <th>
                            分值
                        </th>
                        <th v-for="item in score.p2.m">
                            {{ item.v }}
                        </th>
                        <th v-for="item in score.p2.cq">
                            {{ item.v }}
                        </th>
                        <th v-for="item in score.p2.ca">
                            {{ item.v }}
                        </th>
                        <th v-for="item in score.p2.r">
                            {{ item.v }}
                        </th>
                        <th v-for="item in score.p2.v">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.P_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.P_M_ScoreGroups">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td v-for="s in item.P_CQ_ScoreGroups">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td v-for="s in item.P_CA_ScoreGroups">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td v-for="s in item.P_R_ScoreGroups">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td v-for="s in item.P_V_ScoreGroups">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.P_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--花样 规定元素-->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project &&
                (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                )">
                <!--力量体操-->
                <table border="1">
                    <tr>
                        <th colspan="3">力量体操</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-力量体操')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th>
                            {{ score.q2.p[0].l }}
                        </th>
                        <th>
                            {{ score.q2.p[1].l }}
                        </th>
                        <th rowspan="1">操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_P_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_P_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--多摇-->
                <table border="1">
                    <tr>
                        <th colspan="3">多摇</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-多摇')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th>
                            {{ score.q2.m[0].l }}
                        </th>
                        <th>
                            {{ score.q2.m[1].l }}
                        </th>
                        <th rowspan="1">操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_M_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_M_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--绳子运用-->
                <table border="1">
                    <tr>
                        <th colspan="3">绳子运用</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-绳子运用')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th>
                            {{ score.q2.r[0].l }}
                        </th>
                        <th>
                            {{ score.q2.r[1].l }}
                        </th>
                        <th rowspan="1">操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_R_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_R_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <!--相互配合-->
                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'">
                    <tr>
                        <th colspan="3">相互配合</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样】规定元素Q-互相配合')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            等级
                        </th>
                        <th>
                            {{ score.q2.i[0].l }}
                        </th>
                        <th>
                            {{ score.q2.i[1].l }}
                        </th>
                        <th rowspan="1">操作</th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_I_ScoreGroups">
                        <td>
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_I_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--表演赛 规定元素-->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project
                && (userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    // || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                    || userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD')
            ">
                <table border="1">
                    <tr>
                        <th colspan="6">规定元素</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级表演赛】规定元素')" plain>添加组数</el-button>
                        </th>
                    </tr>
                    <tr>
                        <th>
                            因素
                        </th>
                        <th v-for="item in score.e_q">
                            {{ item.l }}
                        </th>
                        <th rowspan="2">操作</th>
                    </tr>
                    <tr>
                        <th>
                            次数
                        </th>
                        <th v-for="item in score.e_q">
                            {{ item.v }}
                        </th>
                    </tr>
                    <tr v-for="(item, index) in userScoreDetail.Q_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td v-for="s in item.Items">
                            <el-input-number v-model="s.Frequency" controls-position="right" size="mini" :min="0"
                                :max="s.MustFrequency" style="width: 110px;" @change="calcScore"></el-input-number>
                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.Q_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>

            <!--花样 扣分M-->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project &&
                (userScoreDetail.Project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                    || userScoreDetail.Project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                    || userScoreDetail.Project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                )">
                <table border="1">
                    <tr>
                        <th colspan="2">失误m</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】失误m')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.M_M_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.M_M_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <table border="1"
                    v-if="userScoreDetail.Project.ProjectTypeId != '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'">
                    <tr>
                        <th colspan="2">间歇b</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样】间歇b')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.M_B_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.M_B_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
                <table border="1">
                    <tr>
                        <th colspan="2">违例v</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】违例v')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.M_V_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.M_V_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>
            <!--表演赛 扣分M-->
            <div class="score-group-item" style="display: flex;" v-if="userScoreDetail.Project &&
                (userScoreDetail.Project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                    || userScoreDetail.Project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                    || userScoreDetail.Project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                    || userScoreDetail.Project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                    || userScoreDetail.Project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
                )">
                <table border="1">
                    <tr>
                        <th colspan="2">失误m</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】失误m')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.M_M_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.M_M_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>

                <table border="1">
                    <tr>
                        <th colspan="2">违例v</th>
                        <th><el-button size="mini" @click="addScoreGroup('【精英级花样/表演赛】违例v')" plain>添加组数</el-button></th>
                    </tr>
                    <tr>
                        <th>
                            裁判
                        </th>
                        <th>
                            次数
                        </th>
                        <th>操作</th>
                    </tr>

                    <tr v-for="(item, index) in userScoreDetail.M_V_ScoreGroups">
                        <td>
                            <!-- {{ item.referee.RefereeName }} -->
                            <el-select size="mini" style="width: 100px;" v-model="item.referee.RefereeId" filterable
                                placeholder="请选择">
                                <el-option v-for="refer in referees" :key="refer.RefereeId" :label="refer.RefereeName"
                                    :value="refer.RefereeId">
                                </el-option>
                            </el-select>
                        </td>
                        <td>
                            <el-input-number v-model="item.Score" controls-position="right" size="mini"
                                style="width: 110px;" @change="calcScore"></el-input-number>

                        </td>
                        <td> <i class="el-icon-delete"
                                @click="delScoreGroupItem(userScoreDetail.M_V_ScoreGroups, index)"></i>
                        </td>
                    </tr>
                </table>
            </div>


            <div slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="submitScore">提交</el-button>
                <el-button size="mini" @click="editPointDialogVisible = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import MatchService from '@/request-server/request-services/match-services.js';
import SystemService from '@/request-server/request-services/system-services.js';

import Common from '@/utils/utils-common.js';
import Url from '../../../request-server/request-url';
import utilsCommon from '../../../utils/utils-common';
import userScoreData from '../../../data/user-socre.js';

export default {
    data() {
        return {
            allLoading: false,
            matchId: '',
            routeMatchId: '',
            match: null,
            matchOptions: [],
            allMatchs: [],
            choiceMatchDialogVisible: false,
            matchWholeSchedule: [],
            activeNames: [0],
            project: null,
            editProjectContestantUsers: [{
            }],
            rankingOrderType: 0,
            rankingOrderNum: 8,
            isShowDetail: false,
            choicePro: '',
            distributePointRule: [],
            editDistributePointRuleForm: [],
            editDistributePointRuleFormRules: {},
            distributePointDialogVisible: false,
            showTeamRankDialogVisible: false,
            editPointDialogVisible: false,
            score: userScoreData.ScoreModel,
            userScore: {},
            userScoreDetail: {},
            referees: []
        }
    },
    watch: {
        '$route'(to, from) {
            this.getAllMatchs();
            this.getAllReferee();
            this.initData();
        }
    },
    created() {
        this.getAllMatchs();
        this.initData();
        this.getAllReferee();
        this.initDistributePointRule();
    },
    beforeDestroy() {
        this.matchWholeSchedule = null;
        this.project = null;
    },
    methods: {
        initDistributePointRule() {
            SystemService.getDistributePointRule().then(res => {
                if (res.code == 0 && res.data != null) this.distributePointRule = JSON.parse(res.data)
            })
        },
        getAllReferee() {
            SystemService.selectAllReferee().then(res => {
                if (res.code == 0) {
                    this.referees = res.data;
                }
            })
        },
        initData() {
            let id = this.$route.params.id;
            if (id) {
                this.choiceMatchDialogVisible = false;
                this.routeMatchId = id;
                this.$store.commit('matchIdCookie', id);
                this.allLoading = true;

                MatchService.getMatchWholeSchedule({ matchId: this.routeMatchId }).then(res => {
                    if (res.code == 0) {
                        this.matchWholeSchedule = res.data;
                        if (this.choicePro && this.choicePro.ProjectId) {
                            this.matchWholeSchedule.forEach(w => {
                                w.MatchVenueProject.forEach(pro => {
                                    if (pro.ProjectId == this.choicePro.ProjectId) {
                                        this.choiceProject(pro.Project);
                                    }
                                })
                            })
                        }
                        res = null;
                    };
                }).finally(() => {
                    this.allLoading = false;
                });

                if (this.match == null) {
                    MatchService.getMatchDetail({ matchId: this.routeMatchId }).then(res => {
                        if (res.code == 0) this.match = res.data;
                    })
                }
            } else {
                //弹框选择赛事
                //获取开始中的赛事
                if (this.$store.state.matchIdCookie) {
                    this.$router.replace('/mainpage/match-score/' + this.$store.state.matchIdCookie);
                } else {
                    this.choiceMatchDialogVisible = true;
                }
            }
        },
        confirmChoiceMatch() {
            if (this.matchId != '' && this.matchId != this.routeMatchId) {
                this.$store.commit('matchIdCookie', this.matchId)
                this.$router.replace('/mainpage/match-score/' + this.matchId);
            }
            this.choiceMatchDialogVisible = false;
        },
        remoteMethod(query) {
            if (query !== '') {
                this.matchOptions = this.allMatchs.filter(item => {
                    return item.MatchName.indexOf(query) > -1
                })
            } else {
                this.matchOptions = this.allMatchs
            }

        },
        getAllMatchs() {
            MatchService.selectMatchListByName({ matchName: '', signupStatus: '', matchStatus: '' }).then(res => {
                if (res.code == 0) {
                    this.allMatchs = res.data;
                    this.matchOptions = this.allMatchs;
                    this.match = this.allMatchs.find(a => a.MatchId == this.routeMatchId);
                }
            })
        },
        choiceProject(pro) {
            this.project = Common.copyObj(pro);
            this.choicePro = pro;
            this.editProjectContestantUsers = [];

            this.project.Regions.forEach(region => {
                region.ContestantUserGroups.forEach(element => {
                    this.editProjectContestantUsers = [...this.editProjectContestantUsers, ...element.ContestantUsers];
                });

            });

            this.editProjectContestantUsers.forEach(element => {
                element.Ranking = element.Ranking == 0 ? '' : element.Ranking;
            })


            //有名次的
            if (this.editProjectContestantUsers) {
                var rankUsers = this.editProjectContestantUsers.filter(a => a.Ranking > 0);
                rankUsers = rankUsers.sort((a, b) => a.Ranking - b.Ranking);
                //没有名次的
                var notRankUsers = this.editProjectContestantUsers.filter(a => a.Ranking == '');
                notRankUsers = notRankUsers.sort((a, b) => b.Score - a.Score);
                this.editProjectContestantUsers = [...rankUsers, ...notRankUsers]
            };

            this.rankingOrderType = 0;
            this.rankingOrderNum = 8;
            this.isShowDetail = true;
        },
        sysDistributePoint(command) {
            console.log(command);
            if (!this.distributePointRule) {
                this.$message.warning('请先设置派分规则');
                return;
            }
            if (this.editProjectContestantUsers.length == 0) return;

            this.editProjectContestantUsers.forEach(u => {
                u.TotalPoints = 0;
            })

            this.distributePointRule.forEach(element => {
                this.editProjectContestantUsers.filter(a => a.Ranking == element.index).forEach(u => {
                    u.TotalPoints = element.point * command;
                })
            });
            this.submitEdit();
        },

        showTeamRankDialog() {
            this.showTeamRankDialogVisible = true;
        },

        showSetDistributePointDialog() {
            this.editDistributePointRuleForm = utilsCommon.copyObj(this.distributePointRule);
            if (this.editDistributePointRuleForm.length == 0) {
                this.addDistributePointRuleItem();
            }
            this.distributePointDialogVisible = true;
        },
        addDistributePointRuleItem() {
            this.editDistributePointRuleForm.push({ index: this.editDistributePointRuleForm.length + 1, point: 0 })
        },
        submitDistributePoint() {
            let isok = true;
            this.editDistributePointRuleForm.forEach((element, index) => {
                element.index = index + 1;
                if (element.point == '' || element.point <= 0) {
                    this.$message.warning('名词' + (element.index) + '值无效，请核实');
                    isok = false;
                    return;
                }
            });

            if (isok) {
                SystemService.setDistributePointRule({ rule: JSON.stringify(this.editDistributePointRuleForm) }).then(res => {
                    if (res.code == 0) {
                        this.$message.success(res.data);
                        this.distributePointRule = utilsCommon.copyObj(this.editDistributePointRuleForm);
                        this.distributePointDialogVisible = false;
                    }
                })
            }

        },
        // 对符合要求的选手进行排名并分配名次
        rankAndAssignWithOrderByCollectiveIndividualMatch() {
            let minDScore = this.project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F' ? 10 : 20;;
            let rankCount = this.rankingOrderNum;

            let editProjectContestantUsers = Common.copyObj(this.editProjectContestantUsers);

            // 1. 将选手分为两组：符合难度要求的和不符合的
            const qualifiedUsers = [];
            const unqualifiedUsers = [];

            editProjectContestantUsers.forEach(user => {
                const userCopy = { ...user };
                if (user.D_Score >= minDScore) {
                    qualifiedUsers.push(userCopy);
                } else {
                    unqualifiedUsers.push(userCopy);
                }
            });

            // 2. 对符合要求的选手进行排名
            qualifiedUsers.sort((a, b) => b.Score - a.Score);

            let currentRank = 1;
            let usedRanks = 0;

            for (let i = 0; i < qualifiedUsers.length; i++) {
                if (usedRanks >= rankCount) {
                    qualifiedUsers[i].Ranking = null;
                    continue;
                }

                // 统计相同分数的人数
                let sameScoreCount = 1;
                while (
                    i + sameScoreCount < qualifiedUsers.length &&
                    qualifiedUsers[i + sameScoreCount].Score === qualifiedUsers[i].Score
                ) {
                    sameScoreCount++;
                }

                const availableRanks = rankCount - usedRanks;

                if (sameScoreCount > availableRanks) {
                    // 最后一个名次有多人同分
                    for (let j = 0; j < sameScoreCount; j++) {
                        qualifiedUsers[i + j].Ranking = currentRank;
                    }
                    usedRanks = rankCount;
                } else {
                    // 正常分配名次
                    for (let j = 0; j < sameScoreCount; j++) {
                        qualifiedUsers[i + j].Ranking = currentRank;
                    }
                    usedRanks += sameScoreCount;
                    currentRank += sameScoreCount > 1 ? sameScoreCount : 1;
                }

                i += sameScoreCount - 1;
            }

            // 3. 对不符合要求的选手按分数倒序排序
            unqualifiedUsers.sort((a, b) => b.Score - a.Score);
            unqualifiedUsers.forEach(user => {
                user.Ranking = null;
            });

            // 4. 合并数组并替换原数组（改变顺序）
            editProjectContestantUsers.length = 0; // 清空原数组
            editProjectContestantUsers.push(...qualifiedUsers, ...unqualifiedUsers);

            this.editProjectContestantUsers = editProjectContestantUsers;
        },
        rankAndAssignWithOrderByChinaPatternMatch() {
            let rankCount = this.rankingOrderNum;

            let users = Common.copyObj(this.editProjectContestantUsers);
            // 排序
            users.sort((a, b) => {
                if (b.Score !== a.Score) return b.Score - a.Score;
                if (b.CA_Score !== a.CA_Score) return b.CA_Score - a.CA_Score;
                if (b.CQ_Score !== a.CQ_Score) return b.CQ_Score - a.CQ_Score;
                return b.D_Score - a.D_Score;
            });
            // 分配排名
            let currentRank = 1;
            let assignedCount = 0;

            for (let i = 0; i < users.length && assignedCount < rankCount; i++) {
                // 如果是第一个元素，或者与前一个元素不同，则增加排名
                if (i === 0 ||
                    users[i].Score !== users[i - 1].Score ||
                    users[i].CA_Score !== users[i - 1].CA_Score ||
                    users[i].CQ_Score !== users[i - 1].CQ_Score ||
                    users[i].D_Score !== users[i - 1].D_Score) {
                    // 检查是否还有剩余名次
                    if (assignedCount >= rankCount) break;
                    currentRank = assignedCount + 1;
                }

                // 分配排名
                users[i].Ranking = currentRank;
                assignedCount++;

                // 检查是否是最后一个名次且有下一个同分选手
                if (assignedCount === rankCount && i + 1 < users.length) {
                    const nextUser = users[i + 1];
                    if (users[i].Score === nextUser.Score &&
                        users[i].CA_Score === nextUser.CA_Score &&
                        users[i].CQ_Score === nextUser.CQ_Score &&
                        users[i].D_Score === nextUser.D_Score) {
                        // 继续分配相同的排名给下一个同分选手
                        i++;
                        while (i < users.length &&
                            users[i - 1].Score === users[i].Score &&
                            users[i - 1].CA_Score === users[i].CA_Score &&
                            users[i - 1].CQ_Score === users[i].CQ_Score &&
                            users[i - 1].D_Score === users[i].D_Score) {
                            users[i].Ranking = currentRank;
                            i++;
                        }
                        i--; // 调整索引
                    }
                }
            }

            // 为未获得排名的用户设置null
            for (let i = assignedCount; i < users.length; i++) {
                users[i].Ranking = null;
            }

            this.editProjectContestantUsers = users;
        },
        // 精英级项目排序方式，总分相同，则判断1、最少扣分，2、最高规定元素分，3、最高表现分，4、最高难度分
        rankAndAssignWithOrderByEliteMatch() {
            let rankCount = this.rankingOrderNum;

            let users = Common.copyObj(this.editProjectContestantUsers);
            // 排序
            users.sort((a, b) => {
                if (b.Score !== a.Score) return b.Score - a.Score;
                if (b.M_Score !== a.M_Score) return b.M_Score - a.M_Score;
                if (b.Q_Score !== a.Q_Score) return b.Q_Score - a.Q_Score;
                if (b.P_Score !== a.P_Score) return b.P_Score - a.P_Score;
                return b.D_Score - a.D_Score;
            });
            // 分配排名
            let currentRank = 1;
            let assignedCount = 0;

            for (let i = 0; i < users.length && assignedCount < rankCount; i++) {
                // 如果是第一个元素，或者与前一个元素不同，则增加排名
                if (i === 0 ||
                    users[i].Score !== users[i - 1].Score ||
                    users[i].M_Score !== users[i - 1].M_Score ||
                    users[i].Q_Score !== users[i - 1].Q_Score ||
                    users[i].P_Score !== users[i - 1].P_Score ||
                    users[i].D_Score !== users[i - 1].D_Score) {
                    // 检查是否还有剩余名次
                    if (assignedCount >= rankCount) break;
                    currentRank = assignedCount + 1;
                }

                // 分配排名
                users[i].Ranking = currentRank;
                assignedCount++;

                // 检查是否是最后一个名次且有下一个同分选手
                if (assignedCount === rankCount && i + 1 < users.length) {
                    const nextUser = users[i + 1];
                    if (users[i].Score === nextUser.Score &&
                        users[i].M_Score === nextUser.M_Score &&
                        users[i].Q_Score === nextUser.Q_Score &&
                        users[i].P_Score === nextUser.P_Score &&
                        users[i].D_Score === nextUser.D_Score) {
                        // 继续分配相同的排名给下一个同分选手
                        i++;
                        while (i < users.length &&
                            users[i - 1].Score === users[i].Score &&
                            users[i - 1].M_Score === users[i].M_Score &&
                            users[i - 1].Q_Score === users[i].Q_Score &&
                            users[i - 1].P_Score === users[i].P_Score &&
                            users[i - 1].D_Score === users[i].D_Score) {
                            users[i].Ranking = currentRank;
                            i++;
                        }
                        i--; // 调整索引
                    }
                }
            }

            // 为未获得排名的用户设置null
            for (let i = assignedCount; i < users.length; i++) {
                users[i].Ranking = null;
            }

            this.editProjectContestantUsers = users;
        },
        handlerRanking() {
            if (this.editProjectContestantUsers.length == 0) return;
            //国内花样赛排序方式，总分相同，则判断各项评分创意编排、完成质量、难度分
            if (this.project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                || this.project.ProjectTypeId == '528D50AF-3268-45B7-A0B2-6C25D6759095'
            ) {
                this.rankAndAssignWithOrderByChinaPatternMatch();
            } else if (
                this.project.ProjectTypeId == '7427106A-8F3D-4990-803E-C10B92ED618F'
                || this.project.ProjectTypeId == 'D13876D5-FAFA-4CCB-A4DB-92A1B9AF84C3'
            ) {
                this.rankAndAssignWithOrderByCollectiveIndividualMatch();
            }
            else if (this.project.ProjectTypeId == 'DFFA8857-A3C6-46E5-9D21-3B0B0ED54FA8'
                || this.project.ProjectTypeId == '473E6466-059B-4BD6-A6EF-7B23570998C6'
                || this.project.ProjectTypeId == '5AF2F258-BE90-46C0-B95D-2AAA874A5BC9'
                || this.project.ProjectTypeId == 'BAFE00F3-CBDC-42FE-8999-8B60DC255761'
                || this.project.ProjectTypeId == 'DAE84508-5C22-40D1-B872-CCCD5C6A9E6A'
                || this.project.ProjectTypeId == '6C6FC2C5-0E3B-4560-B021-49CCE457C8FD'
                || this.project.ProjectTypeId == 'EC5B512C-37BC-46F4-BFD3-7C5FF3086F14'
                || this.project.ProjectTypeId == '5874F99D-0D4F-49F6-A3A6-BE4867F652B8'
            ) {
                //精英花样赛排序方式，总分相同，则判断1、最少扣分，2、最高规定元素分，3、最高表现分，4、最高难度分
                this.rankAndAssignWithOrderByEliteMatch();
            }
            else {
                if (this.rankingOrderType == 1) {
                    this.editProjectContestantUsers = this.editProjectContestantUsers.sort((a, b) => a.Score - b.Score);
                } else {
                    this.editProjectContestantUsers = this.editProjectContestantUsers.sort((a, b) => b.Score - a.Score);
                }
                this.editProjectContestantUsers.forEach(user => {
                    user.Ranking = '';
                })
                let lastRank = 0;
                for (let index = 1; index <= this.rankingOrderNum; index++) {
                    if (index == 1) {
                        if (this.editProjectContestantUsers[index - 1].Score > 0) {
                            this.editProjectContestantUsers[index - 1].Ranking = index;
                        }
                    } else if (this.editProjectContestantUsers[index - 1].Score < 1 || this.editProjectContestantUsers[index - 1].Score == '') {
                    }
                    else if (this.editProjectContestantUsers.length >= index) {
                        if (this.editProjectContestantUsers[index - 2].Score == this.editProjectContestantUsers[index - 1].Score) {
                            this.editProjectContestantUsers[index - 1].Ranking = this.editProjectContestantUsers[index - 2].Ranking
                        } else {
                            this.editProjectContestantUsers[index - 1].Ranking = index;
                        }
                    }
                    lastRank = index;
                }
                //获取最后一名的分数
                let user = this.editProjectContestantUsers.find(a => a.Ranking == lastRank);
                if (user) {
                    this.editProjectContestantUsers.filter(a => a.Score == user.Score).forEach(u => {
                        u.Ranking = lastRank;
                    })
                }
            }
            this.submitEdit();
        },
        submitEdit() {
            let data = Common.copyObj(this.editProjectContestantUsers);
            data.forEach((element, index) => {

                if (element.ComeOnGroup == '' || element.ComeOnNum == '') {
                    this.$message.error('第' + (index + 1) + '行序号无效，请核对');
                    return;
                }


                element.IsWaiver = element.IsWaiverChecked ? 1 : 0;
                element.IsFoul = element.IsFoulChecked ? 1 : 0;
                element.IsWithdrawMidway = element.IsWithdrawMidwayChecked ? 1 : 0;
                element.IsTest = element.IsTestChecked ? 1 : 0;
                element.IsRecordBreaking = element.IsRecordBreakingChecked ? 1 : 0;
                element.Ranking = element.Ranking <= 0 || element.Ranking == '' ? 0 : element.Ranking;
                element.Score = element.Score <= 0 || element.Score == '' ? 0 : element.Score;
                element.TotalPoints = element.TotalPoints <= 0 || element.TotalPoints == '' ? 0 : element.TotalPoints;
            });

            MatchService.setContestantUserScore(data).then(res => {
                if (res.code == 0) {
                    this.$message.success(res.data);
                    this.initData();
                }
            })

        },
        toMatchRank() {
            var newWindow = window.open(window.origin + '#/match-rank/' + this.routeMatchId, '_blank');
            if (newWindow) {
                // 尝试在新窗口加载后将其置为全屏
                newWindow.onload = function () {
                    if (newWindow.document.fullscreenEnabled) {
                        newWindow.document.documentElement.requestFullscreen().catch(err => {
                            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                        });
                    }
                };
            }
        },
        toMatchScoreView() {
            var newWindow = window.open(window.origin + '#/match-score-view/' + this.routeMatchId, '_blank');
            if (newWindow) {
                // 尝试在新窗口加载后将其置为全屏
                newWindow.onload = function () {
                    if (newWindow.document.fullscreenEnabled) {
                        newWindow.document.documentElement.requestFullscreen().catch(err => {
                            console.error(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`);
                        });
                    }
                };
            }
        },
        exportProjectScore(command) {
            let users = [];
            if (command == 'all') {
                users = utilsCommon.copyObj(this.editProjectContestantUsers);
            } else {
                users = utilsCommon.copyObj(this.editProjectContestantUsers.filter(a => a.Ranking > 0));
            }

            let data = utilsCommon.copyObj(this.project);
            users.forEach(element => {
                element.Ranking = element.Ranking == '' ? 0 : element.Ranking;
            });
            data.Regions = [];
            data.ContestantUserGroups = [{
                ContestantUsers: users
            }]
            MatchService.exportProjectScore(data).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })

        },
        exportAllProjectScore(comm) {
            MatchService.exportAllProjectScore({ matchId: this.routeMatchId, type: comm }).then(res => {
                if (res.code == 0) {
                    this.$message.success('导出成功');
                    location.href = Url.getDownloadBaseUrl() + '/exportfiles/' + res.data;
                }
            })
        },
        setDisclosureStatus() {
            console.log(this.project.IsDisclosure);
            this.$confirm("是否确认要" + (this.project.IsDisclosure == 0 ? '公布' : '隐藏') + "该项目成绩", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    MatchService.setProjectDisclosureStatus({ proId: this.project.ProjectId }).then(res => {
                        if (res.code == 0) {
                            this.$message.success(res.data);
                            this.initData();
                        }
                    })
                })
                .catch(() => { });
        },
        fastGenerateRankPoint(num) {
            this.editDistributePointRuleForm = [];
            for (let index = 1; index <= num; index++) {
                if (index == 1) {
                    this.editDistributePointRuleForm.push({ index: index, point: parseInt(num) + 1 });
                } else {
                    this.editDistributePointRuleForm.push({ index: index, point: num - index + 1 });
                }
            }
        },
        showEditPointDialog(uid) {
            MatchService.getMatchContestantUserScore({ userId: uid }).then((res) => {
                if (res.code == 0) {
                    if (res.data != null) {
                        console.log(res.data);
                        this.userScore = res.data;
                        if (this.userScore.AllScoreJson) {
                            this.userScoreDetail = JSON.parse(this.userScore.AllScoreJson)
                        } else {
                            this.userScoreDetail = {
                                User: {
                                    UserId: uid
                                },
                                Project: {
                                    ProjectTypeId: this.userScore.ProjectTypeId
                                }
                            }
                        }
                    }
                    this.calcScore();
                    this.editPointDialogVisible = true;
                }
            });
        },
        delScoreGroupItem(arr, index) {
            this.$confirm("是否确认要删除该组评分", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    arr.splice(index, 1);
                    this.calcScore();
                })
                .catch(() => { });
        },
        addScoreGroup(type) {
            let referee = {
                RefereeName: '后台系统',
                RefereeId: '5F2373C5-F12B-4A8D-83B0-5AEE52198810'
            };
            if (type == '扣分次数') {
                if (this.userScoreDetail.DeductPointItems == null) {
                    this.userScoreDetail.DeductPointItems = [];
                }
                this.userScoreDetail.DeductPointItems.push({
                    referee: referee, DeductPointCount: 0
                })
            } else if (type == '计次') {
                if (this.userScoreDetail.Times == null) {
                    this.userScoreDetail.Times = [];
                }
                this.userScoreDetail.Times.push({
                    referee: referee, Times: 0
                })
            } else if (type == '创意编排分') {
                if (this.userScoreDetail.CreativeArrangementGroups == null) {
                    this.userScoreDetail.CreativeArrangementGroups = [];
                }
                this.userScoreDetail.CreativeArrangementGroups.push({
                    referee: referee, Score: 0
                })
            } else if (type == '完成质量分') {
                if (this.userScoreDetail.CompletionQualityGroups == null) {
                    this.userScoreDetail.CompletionQualityGroups = [];
                }
                this.userScoreDetail.CompletionQualityGroups.push({
                    referee: referee, Score: 0
                })
            } else if (type == '难度分D') {
                if (this.userScoreDetail.D_ScoreGroups == null) {
                    this.userScoreDetail.D_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.d.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.D_ScoreGroups.push(data);
            } else if (type == '重复难度U') {
                if (this.userScoreDetail.U_ScoreGroups == null) {
                    this.userScoreDetail.U_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.U_ScoreGroups.push(data);
            } else if (type == 'Pa动作技能') {
                if (this.userScoreDetail.Pa_ScoreGroups == null) {
                    this.userScoreDetail.Pa_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.p.pa.forEach(item => {
                    data.Items.push({
                        Record: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Pa_ScoreGroups.push(data);
            } else if (type == 'Pr娱乐编排') {
                if (this.userScoreDetail.Pr_E_ScoreGroups == null) {
                    this.userScoreDetail.Pr_E_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.p.pre.forEach(item => {
                    data.Items.push({
                        Record: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Pr_E_ScoreGroups.push(data);
            } else if (type == 'Pr音乐运用') {
                if (this.userScoreDetail.Pr_M_ScoreGroups == null) {
                    this.userScoreDetail.Pr_M_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.p.prm.forEach(item => {
                    data.Items.push({
                        Record: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Pr_M_ScoreGroups.push(data);
            } else if (type == 'Fs形式风格') {
                if (this.userScoreDetail.FS_ScoreGroups == null) {
                    this.userScoreDetail.FS_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.p.fs.forEach(item => {
                    data.Items.push({
                        Record: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.FS_ScoreGroups.push(data);
            } else if (type == '规定Q') {
                if (this.userScoreDetail.Q_ScoreGroups == null) {
                    this.userScoreDetail.Q_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.q.forEach(item => {
                    data.Items.push({
                        Type: item.l,
                        Score: item.t,
                        MaxScoreValue: item.v
                    })
                })
                this.userScoreDetail.Q_ScoreGroups.push(data);
            }
            else if (type == '【集体自编赛】规定Q') {
                if (this.userScoreDetail.Q_ScoreGroups == null) {
                    this.userScoreDetail.Q_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.c_q.forEach(item => {
                    data.Items.push({
                        Type: item.l,
                        Score: item.t,
                        MaxScoreValue: item.v
                    })
                })
                this.userScoreDetail.Q_ScoreGroups.push(data);
            }
            else if (type == 'Pa失误') {
                if (this.userScoreDetail.Mistake_Pa_ScoreGroups == null) {
                    this.userScoreDetail.Mistake_Pa_ScoreGroups = [];
                }
                let data = {
                    referee: referee, ScoreValue: 0.025, Score: 0
                }
                this.userScoreDetail.Mistake_Pa_ScoreGroups.push(data);
            } else if (type == 'Q失误') {
                if (this.userScoreDetail.Mistake_Q_ScoreGroups == null) {
                    this.userScoreDetail.Mistake_Q_ScoreGroups = [];
                }
                let data = {
                    referee: referee, ScoreValue: 0.025, Score: 0
                }
                this.userScoreDetail.Mistake_Q_ScoreGroups.push(data);
            } else if (type == '违例') {
                if (this.userScoreDetail.V_ScoreGroups == null) {
                    this.userScoreDetail.V_ScoreGroups = [];
                }
                let data = {
                    referee: referee, ScoreValue: 0.025, Score: 0
                }
                this.userScoreDetail.V_ScoreGroups.push(data);
            } else if (type == '【国内集体规定赛】完成质量') {
                if (this.userScoreDetail.CompletionQualityGroups == null) {
                    this.userScoreDetail.CompletionQualityGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.ctr_cq.forEach(item => {
                    data.Items.push({
                        Type: item.t,
                        Score: 0,
                        MaxScoreValue: item.m
                    })
                })
                this.userScoreDetail.CompletionQualityGroups.push(data);
            } else if (type == '【国内个人规定赛】完成质量') {
                if (this.userScoreDetail.CompletionQualityGroups == null) {
                    this.userScoreDetail.CompletionQualityGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.cpr_cq.forEach(item => {
                    data.Items.push({
                        Type: item.t,
                        Score: 0,
                        MaxScoreValue: item.m
                    })
                })
                this.userScoreDetail.CompletionQualityGroups.push(data);
            } else if (type == "【国内个人/集体规定赛】创意编排") {
                if (this.userScoreDetail.CreativeArrangementGroups == null) {
                    this.userScoreDetail.CreativeArrangementGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.cr_ca.forEach(item => {
                    data.Items.push({
                        Type: item.t,
                        Score: 0,
                        MaxScoreValue: item.m
                    })
                })
                this.userScoreDetail.CreativeArrangementGroups.push(data);
            } else if (type == '一级难度') {
                if (this.userScoreDetail.D1_ScoreGroups == null) {
                    this.userScoreDetail.D1_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Level: this.score.c_d1.l, ScoreValue: this.score.c_d1.v, Score: 0
                }
                this.userScoreDetail.D1_ScoreGroups.push(data);

            } else if (type == '二级难度') {
                if (this.userScoreDetail.D2_ScoreGroups == null) {
                    this.userScoreDetail.D2_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Level: this.score.c_d2.l, ScoreValue: this.score.c_d2.v, Score: 0
                }
                this.userScoreDetail.D2_ScoreGroups.push(data);

            } else if (type == '三级难度') {
                if (this.userScoreDetail.D3_ScoreGroups == null) {
                    this.userScoreDetail.D3_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Level: this.score.c_d3.l, ScoreValue: this.score.c_d3.v, Score: 0
                }
                this.userScoreDetail.D3_ScoreGroups.push(data);

            } else if (type == '重复一级难度') {
                if (this.userScoreDetail.U1_ScoreGroups == null) {
                    this.userScoreDetail.U1_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Level: this.score.c_u1.l, ScoreValue: this.score.c_u1.v, Score: 0
                }
                this.userScoreDetail.U1_ScoreGroups.push(data);

            } else if (type == '重复二级难度') {
                if (this.userScoreDetail.U2_ScoreGroups == null) {
                    this.userScoreDetail.U2_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Level: this.score.c_u2.l, ScoreValue: this.score.c_u2.v, Score: 0
                }
                this.userScoreDetail.U2_ScoreGroups.push(data);

            } else if (type == '重复三级难度') {
                if (this.userScoreDetail.U3_ScoreGroups == null) {
                    this.userScoreDetail.U3_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Level: this.score.c_u3.l, ScoreValue: this.score.c_u3.v, Score: 0
                }
                this.userScoreDetail.U3_ScoreGroups.push(data);
            } else if (type == '【国内表演赛/花样赛】创意编排') {
                if (this.userScoreDetail.CA_ScoreGroups == null) {
                    this.userScoreDetail.CA_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.c_ca.forEach(item => {
                    data.Items.push({
                        Type: item.t,
                        Score: 0,
                        MaxScore: item.m
                    })
                })
                this.userScoreDetail.CA_ScoreGroups.push(data);
            } else if (type == '【国内表演赛/花样赛】完成质量') {
                if (this.userScoreDetail.CQ_ScoreGroups == null) {
                    this.userScoreDetail.CQ_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.c_cq.forEach(item => {
                    data.Items.push({
                        Type: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.CQ_ScoreGroups.push(data);
            } else if (type == '【国内表演赛】规定元素') {
                if (this.userScoreDetail.Q_ScoreGroups == null) {
                    this.userScoreDetail.Q_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.c_q.forEach(item => {
                    data.Items.push({
                        Type: item.l,
                        Frequency: item.t,
                        MustFrequency: item.v
                    })
                })
                this.userScoreDetail.Q_ScoreGroups.push(data);

            } else if (type == '【国内花样赛】规定元素') {
                if (this.userScoreDetail.Q_ScoreGroups == null) {
                    this.userScoreDetail.Q_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.c_q2.forEach(item => {
                    data.Items.push({
                        Type: item.l,
                        Frequency: this.userScoreDetail.Project.ProjectTypeId == '39E56A5E-CB75-4245-AA8C-C0553C6C4ADF'
                            && item.l == '互相配合' ? null : item.t,
                        MustFrequency: item.v
                    })
                })
                this.userScoreDetail.Q_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DP难度分') {
                if (this.userScoreDetail.DP_ScoreGroups == null) {
                    this.userScoreDetail.DP_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.dp.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DP_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DM难度分') {
                if (this.userScoreDetail.DM_ScoreGroups == null) {
                    this.userScoreDetail.DM_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.dm.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DM_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DR难度分') {
                if (this.userScoreDetail.DR_ScoreGroups == null) {
                    this.userScoreDetail.DR_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.dr.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DR_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DA难度分') {
                if (this.userScoreDetail.DA_ScoreGroups == null) {
                    this.userScoreDetail.DA_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.da.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DA_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DB难度分') {
                if (this.userScoreDetail.DB_ScoreGroups == null) {
                    this.userScoreDetail.DB_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.db.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DB_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DT难度分') {
                if (this.userScoreDetail.DT_ScoreGroups == null) {
                    this.userScoreDetail.DT_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.dt.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DT_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DJ难度分') {
                if (this.userScoreDetail.DJ_ScoreGroups == null) {
                    this.userScoreDetail.DJ_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.dj.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.DJ_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DP重复难度分') {
                if (this.userScoreDetail.UDP_ScoreGroups == null) {
                    this.userScoreDetail.UDP_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u_dp.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.UDP_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DM重复难度分') {
                if (this.userScoreDetail.UDM_ScoreGroups == null) {
                    this.userScoreDetail.UDM_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u_dm.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.UDM_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DR重复难度分') {
                if (this.userScoreDetail.UDR_ScoreGroups == null) {
                    this.userScoreDetail.UDR_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u_dr.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.UDR_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DA重复难度分') {
                if (this.userScoreDetail.UDA_ScoreGroups == null) {
                    this.userScoreDetail.UDA_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u_da.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.UDA_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DB重复难度分') {
                if (this.userScoreDetail.UDB_ScoreGroups == null) {
                    this.userScoreDetail.UDB_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u_db.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.UDB_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】DT重复难度分') {
                if (this.userScoreDetail.UDT_ScoreGroups == null) {
                    this.userScoreDetail.UDT_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.u_dt.forEach(item => {
                    data.Items.push({
                        RankName: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.UDT_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】表现P') {
                if (this.userScoreDetail.P_ScoreGroups == null) {
                    this.userScoreDetail.P_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    P_M_ScoreGroups: [],
                    P_CQ_ScoreGroups: [],
                    P_CA_ScoreGroups: [],
                    P_R_ScoreGroups: [],
                    P_V_ScoreGroups: []
                }
                this.score.p2.m.forEach(item => {
                    data.P_M_ScoreGroups.push({
                        Record: item.l,
                        Score: item.t
                    })
                })
                this.score.p2.cq.forEach(item => {
                    data.P_CQ_ScoreGroups.push({
                        Record: item.l,
                        Score: item.t
                    })
                })
                this.score.p2.ca.forEach(item => {
                    data.P_CA_ScoreGroups.push({
                        Record: item.l,
                        Score: item.t
                    })
                })
                this.score.p2.r.forEach(item => {
                    data.P_R_ScoreGroups.push({
                        Record: item.l,
                        Score: item.t
                    })
                })
                this.score.p2.v.forEach(item => {
                    data.P_V_ScoreGroups.push({
                        Record: item.l,
                        Score: item.t
                    })
                })
                this.userScoreDetail.P_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样】规定元素Q-力量体操') {
                if (this.userScoreDetail.Q_P_ScoreGroups == null) {
                    this.userScoreDetail.Q_P_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Items: []
                }
                this.score.q2.p.forEach(item => {
                    data.Items.push({
                        Level: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Q_P_ScoreGroups.push(data);

            }
            else if (type == '【精英级花样】规定元素Q-多摇') {
                if (this.userScoreDetail.Q_M_ScoreGroups == null) {
                    this.userScoreDetail.Q_M_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Items: []
                }
                this.score.q2.m.forEach(item => {
                    data.Items.push({
                        Level: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Q_M_ScoreGroups.push(data);

            }
            else if (type == '【精英级花样】规定元素Q-绳子运用') {
                if (this.userScoreDetail.Q_R_ScoreGroups == null) {
                    this.userScoreDetail.Q_R_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Items: []
                }
                this.score.q2.r.forEach(item => {
                    data.Items.push({
                        Level: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Q_R_ScoreGroups.push(data);

            }
            else if (type == '【精英级花样】规定元素Q-互相配合') {

                if (this.userScoreDetail.Q_I_ScoreGroups == null) {
                    this.userScoreDetail.Q_I_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Items: []
                }
                this.score.q2.initDistributePointRule.forEach(item => {
                    data.Items.push({
                        Level: item.l,
                        Score: 0,
                        ScoreValue: item.v
                    })
                })
                this.userScoreDetail.Q_I_ScoreGroups.push(data);

            }
            else if (type == '【精英级花样/表演赛】失误m') {
                if (this.userScoreDetail.M_M_ScoreGroups == null) {
                    this.userScoreDetail.M_M_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Score: 0
                }
                this.userScoreDetail.M_M_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样】间歇b') {
                if (this.userScoreDetail.M_B_ScoreGroups == null) {
                    this.userScoreDetail.M_B_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Score: 0
                }
                this.userScoreDetail.M_B_ScoreGroups.push(data);
            }
            else if (type == '【精英级花样/表演赛】违例v') {
                if (this.userScoreDetail.M_V_ScoreGroups == null) {
                    this.userScoreDetail.M_V_ScoreGroups = [];
                }
                let data = {
                    referee: referee,
                    Score: 0
                }
                this.userScoreDetail.M_V_ScoreGroups.push(data);
            }
            else if (type == '【精英级表演赛】规定元素') {
                if (this.userScoreDetail.Q_ScoreGroups == null) {
                    this.userScoreDetail.Q_ScoreGroups = [];
                }
                let data = {
                    referee: referee, Items: []
                }
                this.score.e_q.forEach(item => {
                    data.Items.push({
                        Type: item.l,
                        Frequency: item.t,
                        MustFrequency: item.v
                    })
                })
                this.userScoreDetail.Q_ScoreGroups.push(data);

            }


            console.log(this.userScoreDetail)

            this.calcScore();
        },
        submitScore() {
            MatchService.editUserScoreDetail({ json: JSON.stringify(this.userScoreDetail) }).then(res => {
                if (res.code == 0) {
                    this.editPointDialogVisible = false;
                    this.$message.success(res.data);
                    this.initData();
                }
            })
        },
        calcScore() {
            MatchService.calcScore({ json: JSON.stringify(this.userScoreDetail) }).then(res => {
                if (res.code == 0) {
                    this.userScoreDetail = JSON.parse(res.data);
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.project-list {
    height: 100%;
    overflow: hidden;
    overflow-y: auto;
}

.pro-item {
    min-height: 30px;
    border-bottom: 1px solid #e3e3e3;
    cursor: pointer;
    padding: 10px 10px;
    box-sizing: border-box;
}

.pro-item:hover {
    background-color: #FAFAFA;
}

.pro-item span {
    color: #666;
}

.choicePro {
    background-color: #c1e0ff;
    font-weight: 600;
}

.details {
    padding: 10px 30px;
    box-sizing: border-box;
}

.pro-name {
    font-size: 22px;
    font-weight: 600;
    height: 40px;
    line-height: 40px;
}

table {
    border-collapse: collapse;
    margin: 10px;
    /* 合并边框 */
}

th,
td {
    border: 2px solid #e3e3e3;
    /* 设置边框宽度为2px，颜色为蓝色 */
    width: 120px;
    text-align: center;
    height: 35px;
}

th {
    background-color: #d3d2d2;
    color: #000;
}

.score-group-item {
    margin-top: 10px;
}

.el-icon-delete {
    color: red;
    cursor: pointer;
}
</style>
